import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router, NavigationExtras } from '@angular/router';
import { BaseProvider } from '../BaseProvider';
import { AccountResponseModel, LoginResponseModel } from '../../_models/index';
@Injectable()
export class AccountService extends BaseProvider {
    resource = 'accounts';

    constructor(private http: Http, private router: Router) {
        super(http);
    }
    getAccounts(partnerId: string) { // Fetch all accounts given the token accounts?partnerId=1cd2c68c8da041e79159a0b14861e936
        return this.makeGetCall(this.resource + '?partnerId=' + partnerId);
    }
    getAccountDetailsById(accountId: string) { // Fetch a particular account details given the id
        return this.makeGetCall(this.resource + '/' + accountId);
    }
    addAccount(accountRequest: AccountResponseModel) {  // Add an account  given the account details
        return this.makePostCall(this.resource, accountRequest);
    }
    editAccount(account) {// TODO: to be removed from here
        const navigationExtras: NavigationExtras = {
            queryParams: {
                'id': account.id
            }
        };
        this.router.navigate(['/admin/bank-account/edit'], navigationExtras);
    }
    updateAccount(account: AccountResponseModel) { // Update an account  given the updated account details
        return this.makePutCall(this.resource + '/' + account.id, account)
    }
    deleteAccount(accountId) { // Delete an account  given the account id
        return this.makeDeleteCall(this.resource + '/' + accountId)
    }
    addConsumerBankAcc(requestModel) {
        return this.makePostCall('bankAccount', requestModel);
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/account/accounts.service.ts